var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/alert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39 39H33V21H39M39 51H33V45H39M36 6C32.0603 6 28.1593 6.77597 24.5195 8.28361C20.8797 9.79125 17.5726 12.001 14.7868 14.7868C9.1607 20.4129 6 28.0435 6 36C6 43.9565 9.1607 51.5871 14.7868 57.2132C17.5726 59.999 20.8797 62.2087 24.5195 63.7164C28.1593 65.224 32.0603 66 36 66C43.9565 66 51.5871 62.8393 57.2132 57.2132C62.8393 51.5871 66 43.9565 66 36C66 32.0603 65.224 28.1593 63.7164 24.5195C62.2087 20.8797 59.999 17.5726 57.2132 14.7868C54.4274 12.001 51.1203 9.79125 47.4805 8.28361C43.8407 6.77597 39.9397 6 36 6Z",
    fill: "#28519e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBlue);
export default __webpack_public_path__ + "static/media/alert-blue.259fb5b1fd37362ca34225268a7bbf8d.svg";
export { ForwardRef as ReactComponent };